<template>
  <div>
    <slot name="default" :mallFields="mallFields">
      <v-row no-gutters>
        <v-col v-for="mallField in mallFields" :key="mallField.key" cols="12" class="mall-field">
          <p class="mb-1">{{ mallField.label }}</p>
          <template v-if="mallField.isPassword">
            <v-text-field
              v-model="mallField.value"
              solo
              single-line
              hide-details
              outlined
              flat
              autocomplete="on"
              :placeholder="mallField.placeholder"
              :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
              :type="passwordShow ? 'text' : 'password'"
              @click:append="passwordShow = !passwordShow"
            ></v-text-field>
          </template>

          <template v-else>
            <v-text-field
              v-model="mallField.value"
              solo
              single-line
              hide-details
              outlined
              flat
              :placeholder="mallField.placeholder"
            ></v-text-field>
          </template>
        </v-col>
      </v-row>
    </slot>

    <slot name="activator" :syncFields="syncFields"></slot>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { toCamel } from '@/util'

export default {
  props: {
    providerCode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      currentMall: null,
      mallFields: [],
      passwordShow: false,
    }
  },
  computed: {
    ...mapGetters('mall', ['providersObj']),
    credentials() {
      const fields = this.currentMall?.credentialsFields || []
      return fields.filter((f) => f.isHidden === false)
    },
    isValid() {
      return this.mallFields.every((f) => !!f.value)
    },
  },
  watch: {
    credentials(nv) {
      const result = nv.map((field) => {
        const key = toCamel(field.fieldName)
        return {
          key,
          value: null,
          label: field.label,
          placeholder: field.placeholder,
          isPassword: field.isPassword,
          order: field.order,
        }
      })
      result.sort((a, b) => a.order - b.order)

      this.mallFields = result
    },
    isValid(v) {
      this.$emit('update:isValid', v)
    },
  },
  async created() {
    if (!this.providersObj) {
      await this.getMallProviders()
    }

    this.currentMall = this.providersObj[this.providerCode]
  },
  methods: {
    ...mapActions('mall', ['getMallProviders']),
    syncFields() {
      this.$emit('update:mallFields', this.mallFields)
    },
  },
}
</script>

<style lang="scss" scoped>
.mall-field {
  margin-bottom: 20px;
}
</style>
